import React from "react";
import { useFormContext } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { showConditionsModal } from "../../modules/registration/slices/register.slice";
import { showGeneralModal } from "../../modules/settings/slices/settings.slice";
import { isHiddenForStores, STORES_ID } from "../../utils/stores";
import { Checkbox } from "../controls/Checkbox";

export const ConsentsContainer = (props) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const storeId = useSelector((state) => state.settings.storeId);
	const privacyPolicyUrl = useSelector(
		(state) => state.settings.privacyPolicyUrl,
	);
	const identityEnableVippsLogin = useSelector(
		(state) => state.settings.features.identityEnableVippsLogin,
	);

	const acceptSalesConditions = useSelector(
		(state) => state.registration.b2c.form.acceptSalesConditions,
	);

	const { FORM_FIELDS, getValues } = useFormContext();

	const onOffersInformationModalShow = (e) => {
		e.preventDefault();
		dispatch(
			showGeneralModal({
				formattedTitle: { id: "gdpr.consents.information.modal.title" },
				formattedContent: {
					id: "gdpr.consents.information.modal.info",
					tagName: "div",
				},
			}),
		);
	};

	const currentEmailNotificationValue = getValues("acceptEmailNotifications");
	const currentSmsNotificationValue = getValues("acceptSMSNotifications");

	return (
		<>
			<div className="form-text-spacer">
				<p className="form-text">
					<FormattedMessage
						id="gdpr.consents.info.text"
						values={{
							offersInformationLink: (
								<a
									href="#"
									target="_blank"
									onClick={onOffersInformationModalShow}
								>
									{formatMessage({ id: "gdpr.consents.info.link" })}
								</a>
							),
						}}
					/>
				</p>
			</div>

			<Checkbox
				id="acceptEmailNotifications"
				name="acceptEmailNotifications"
				ref={FORM_FIELDS.ACCEPT_EMAIL_NOTIFICATIONS.FIELD.ref}
				error={FORM_FIELDS.ACCEPT_EMAIL_NOTIFICATIONS.ERROR}
				value={currentEmailNotificationValue}
				className="form-input"
				label={formatMessage({ id: "Consents.NewsletterEmail.Text" })}
				onChange={props.onFieldChange}
			/>

			{!isHiddenForStores({
				stores: [STORES_ID["318"], STORES_ID["324"], STORES_ID["325"]],
				storeId,
			}) && (
				<>
					<Checkbox
						id="acceptSMSNotifications"
						name="acceptSMSNotifications"
						ref={FORM_FIELDS.ACCEPT_SMS_NOTIFICATIONS.FIELD.ref}
						error={FORM_FIELDS.ACCEPT_SMS_NOTIFICATIONS.ERROR}
						value={currentSmsNotificationValue}
						className="form-input"
						label={formatMessage({ id: "Consents.NewsletterSMS.Text" })}
						onChange={props.onFieldChange}
					/>
				</>
			)}

			<div className="form-text-spacer">
				<p className="form-text">
					<FormattedMessage
						id="gdpr.consents.info.privacytext"
						values={{
							privacyPolicyLink: (
								<a target="_blank" rel="noreferrer" href={privacyPolicyUrl}>
									{formatMessage({ id: "gdpr.consents.info.privacylink" })}
								</a>
							),
						}}
					/>
				</p>
			</div>
			{!identityEnableVippsLogin && (
				<Checkbox
					id="acceptSalesConditions"
					name="acceptSalesConditions"
					ref={FORM_FIELDS.ACCEPT_SALES_CONDITIONS.FIELD.ref}
					error={FORM_FIELDS.ACCEPT_SALES_CONDITIONS.ERROR}
					value={acceptSalesConditions}
					className="form-input"
					label={formatMessage({ id: "profile.SalesConditionsAccept" }) + " "}
					linkText={formatMessage({
						id: "profile.SalesConditionsAcceptLinkText",
					})}
					onChange={props.onFieldChange}
					onLinkClick={() => dispatch(showConditionsModal())}
				/>
			)}
		</>
	);
};
